import React, { Component } from 'react';
import Alert from 'react-s-alert';

import _ from 'lodash';

import App from './App.jsx';
import Modelo from './Modelo.jsx';

import type { T_Sen } from './types.js';
import type { T_Info } from './DialogSensor.jsx';

// const validator = require('email-validator');

type T_AlertasUPL = {
  culti: string,
  cultivo: string,
  email: string,
  enfermedad: string,
  estado: boolean,
  id: number,
  lat: number,
  lng: number,
  path: string,
  superficie: number,
  uuid: string
}

export type T_AlertasActivasUPL = {
  cultivo: string,
  enfermedad: string,
  estado: boolean,
  fecha: string,
  id: number,
  semanal: boolean,
  uuid: string
}

export type T_InfoWeek = {
  temp: number,
  hum: number,
  pre: number,
  rad_global: number,
  rad_directa: number,
  wind_speed?: number,
  wind_deg?: number,
  clouds?: number,
  dpv: number,
  mh: number,
  fecha: string,
  hora_local: string
}

type T_DialogSensorCultivoUPLProps = {
  app: App,
  cultivo: T_Cultivo,
  data: Array<T_Info>,
  data_diaria: Array<object>,
  sen: T_Sen,
  superficie: number
}

type T_DialogSensorCultivoUPLState = {
  activa: boolean,
  alertas: Array<T_AlertasUPL>,
  alertas_count: boolean,
  alertas_data: Array<T_AlertasActivasUPL>,
  enfermedad: string,
  email: string,
  evapoSum: number,
  week_data: Array<T_InfoWeek>
}

export default class DialogSensorCultivoUPL extends Component<T_DialogSensorCultivoUPLProps, T_DialogSensorCultivoUPLState> {
  constructor(props) {
    super(props);

    this.state = {
      activa: false,
      alertas: [],
      alertas_data: [],
      alertas_count: undefined, // Para que aparezca gris el color al iniciar el módulo
      enfermedad: '',
      email: '',
      evapoSum: -1,
      week_data: []
    };
  }

  async componentDidMount() {

    const
      { app, cultivo, data_diaria, sen } = this.props,
      { path, uuid } = this.props.sen,
      enfermedades = cultivo.enfermedades_data.map(ed => ed.enfermedad)
    ;

    const url_week_data = `${app.remote}/get-week-data-upl/?session_id=${app.session()}&path=${sen.path}&uuid=${sen.uuid}`;

    await fetch(url_week_data).then(res => res.json()).then(week_data => {
      this.setState({ week_data }, () => this.setColorRiesgo(this.state.week_data, data_diaria));
    });

    const url_alertas = `${app.remote}/get-alertas-upl/?session_id=${app.session()}&cultivo=${_.toLower(cultivo.cultivo)}&path=${path}&uuid=${uuid}`;
    
    await fetch(url_alertas).then(res => res.json()).then(alertas => {
      this.setState({ alertas });
    });
    
    const url_activas = `${app.remote}/get-alertas-activas-upl/?session_id=${app.session()}`

    const post = {
      method: 'POST',
      body: JSON.stringify({ uuid, cultivo: _.toLower(cultivo.cultivo), enfermedades }),
      headers: { 'Content-Type': 'application/json' }
    };

    await fetch(url_activas, post).then(res => res.json()).then(data => {
      if (data.count > 0) {
        this.setState({ alertas_count: true, alertas_data: data.rows });
      } else {
        this.setState({ alertas_count: false });
      }
    });
  }

  setColorRiesgo = (week_data: Array<T_InfoWeek>, diaria_week: Array<object>) => {
    const
      evapo = diaria_week.map(data => parseFloat(data.evapotrans)),
      evapoSum = evapo.length > 0 ? evapo.reduce((a, b) => a + b) : 44
    ;

    this.setState({ evapoSum });
  }

  emailChange = (ev: SyntheticInputEvent<*>): void => {
    const email = ev.target.value;

    this.setState({ email });
  }

  changeSwitch = (event)  =>{

    const
      valor = event.target.checked,
      { app, superficie } = this.props,
      { enfermedad, email } = this.state,
      { uuid, path, lat, lng } = this.props.sen,
      culti = _.capitalize(path.split('/')[4].replace(/_/g, ' ')),
      cultivo = _.toLower(this.props.cultivo.cultivo)

    const alertaStatus = valor;

    const post = {
        method: 'POST',
        body: JSON.stringify({ 
          uuid,
          enfermedad,
          lat,
          lng,
          email,
          cultivo,
          alertaStatus,
          culti,
          superficie
        }), 
        headers: { 'Content-Type': 'application/json' }
      };
      fetch(`${app.remote}/post-alerta-upl/?session_id=${app.session()}&path=${path}`, post).then(res => res.json()).then(data => {
        if (data.ok === 'Target actualizado.') {
        } else if (data.ok === 'Target desactivado.') {
          Alert.error('La alerta ha sido desactivada', { position: 'bottom-left' });
          this.setState({ activa: false });
        } else if (data.ok === 'Target activado.') {
          Alert.success('La alerta ha sido activada', { position: 'bottom-left' });
          this.setState({ activa: true });
        } else if (data.ok === 'Target guardado.') {
          Alert.success('La alerta ha sido creada.', { position: 'bottom-left' });
          this.setState({ activa: true });
        } else if (data.error) {
          Alert.error('Hubo un problema al leer la base de datos.', { position: 'bottom-left'});
        }
      }).then(async () => {
        const url_alertas = `${app.remote}/get-alertas-upl/?session_id=${app.session()}&cultivo=${_.toLower(this.props.cultivo.cultivo)}&path=${path}&uuid=${uuid}`;
    
        await fetch(url_alertas).then(res => res.json()).then(alertas => {
          this.setState({ alertas });
        });
      });
    // } else {
    //   Alert.error('El email no es válido.', { position: 'bottom-left' });
    // }
    
  }

  submitAlarmaUPL = (ev: SyntheticInputEvent<*>): void => {
    ev.preventDefault();
    const
      { app, superficie } = this.props,
      { enfermedad, email } = this.state,
      { uuid, path, lat, lng } = this.props.sen,
      culti = _.capitalize(path.split('/')[4].replace(/_/g, ' ')),
      cultivo = _.toLower(this.props.cultivo.cultivo),
      data = new FormData(ev.target),
      alertaStatus = data.get('activateSwitch') !== 'on' ? false : true
      // valid_email = validator.validate(email)
    ;

    // if (email) {
      const post = {
        method: 'POST',
        body: JSON.stringify({ 
          uuid,
          enfermedad,
          lat,
          lng,
          email,
          cultivo,
          alertaStatus,
          culti,
          superficie
        }), 
        headers: { 'Content-Type': 'application/json' }
      };
      fetch(`${app.remote}/post-alerta-upl/?session_id=${app.session()}&path=${path}`, post).then(res => res.json()).then(data => {
        if (data.ok === 'Target actualizado.') {
          Alert.success('El correo ha sido modificado.', { position: 'bottom-left' });
        } else if (data.ok === 'Target desactivado.') {
          this.setState({ activa: false });
        } else if (data.ok === 'Target activado.') {
          this.setState({ activa: true });
        } else if (data.ok === 'Target guardado.') {
          this.setState({ activa: true });
        } else if (data.error) {
          Alert.error('Hubo un problema al leer la base de datos.', { position: 'bottom-left'});
        }
      }).then(async () => {
        const url_alertas = `${app.remote}/get-alertas-upl/?session_id=${app.session()}&cultivo=${_.toLower(this.props.cultivo.cultivo)}&path=${path}&uuid=${uuid}`;
    
        await fetch(url_alertas).then(res => res.json()).then(alertas => {
          this.setState({ alertas });
        });
      });
    // } else if (email === '') {
    //   Alert.error('El email no es válido.', { position: 'bottom-left' });
    // }
  }

  select_enfermedad = (ev: SyntheticInputEvent<*>) => {
    const
      { alertas } = this.state,
      enfermedad = ev.target.value;
    ;

    this.setState({
      enfermedad: '',
      email: '',
      activa: false
    }, () => {
      this.setState({ enfermedad }, () => {
        alertas.forEach(alerta => {
          if (alerta.enfermedad === enfermedad) {
            this.setState({ 
              email: alerta.email,
              activa: alerta.estado
              // submitAlarmaUPL()
            });
          }
        });
      });
    });
  };

  renderNivelRiesgo = (enfermedad_data, alertas_count, evapoSum) => {
    const alertas = Array.from(this.state.alertas_data);
    let alertaColor = '';
  
    // if (this.state.activa) {
      // const alertas_enfermedad_seleccionada = alertas.filter(e => e.enfermedad === this.state.enfermedad);
      const alertas_enfermedad_seleccionada = alertas.filter(e => e.enfermedad === enfermedad_data.enfermedad);
      const alerta = alertas_enfermedad_seleccionada.find(alerta => alerta.recom === 'curativa')
        ? alertas_enfermedad_seleccionada.find(alerta => alerta.recom === 'curativa')
        : alertas_enfermedad_seleccionada.find(alerta => alerta.recom === 'preventiva' || 'norecom');
      
      let tipo_enfermedad, dias;
    
      if (alerta) {
        tipo_enfermedad = alerta.recom;
        const last_enfermedad = alertas_enfermedad_seleccionada.pop();
        const fecha_enf = new Date(last_enfermedad.fecha).getTime();
        const fecha_actual = new Date().getTime();
        const diff = fecha_actual - fecha_enf;
        dias = diff / 86400000;
      }
      
      if (tipo_enfermedad === 'curativa' && dias >= 7 ) { alertaColor = '#c31200'; }
      else if (tipo_enfermedad === 'curativa') { alertaColor = '#EF800B'; }
      else if (tipo_enfermedad === 'preventiva') { alertaColor = '#efd144'; }
      // else if (tipo_enfermedad === 'preventiva') { alertaColor = '#43be3f'; }
      else if (tipo_enfermedad === 'norecom') { alertaColor = '#bfbfbf'; }
      else { alertaColor = '#bfbfbf'; }
    // } else { alertaColor = '#bfbfbf'; }

    return (
      <div className="alerta-circle" style={{ backgroundColor: alertaColor }}>
        {/* <div
          className="tooltip-text tooltip-bottom"
          style={{ width: '225px', left: '-310%', top: '52px', fontFamily: 'Raleway', fontWeight: 'bolder' }}
        >
          <div style={{ fontSize: '20px', borderBottom: '1px solid white' }}>
            <p style={{ marginBottom: '0px' }}>NIVEL DE RIESGO</p>
          </div>
          <div style={{ margin: '20px 10px 0px 10px' }}>
            <div style={{ display: 'flex', fontSize: '18px', marginBottom: '10px' }}>
              <div className="alerta-circleTooltip" style={{ backgroundColor: '#43be3f' }} />
              <p style={{ marginTop: '3px' }}>BAJO</p>
            </div>
            <div style={{ display: 'flex', fontSize: '18px', marginBottom: '10px' }}>
              <div className="alerta-circleTooltip" style={{ backgroundColor: '#efd144' }} />
              <p style={{ marginTop: '3px' }}>INTERMEDIO</p>
            </div>
            <div style={{ display: 'flex', fontSize: '18px', marginBottom: '10px' }}>
              <div className="alerta-circleTooltip" style={{ backgroundColor: '#c31200' }} />
              <p style={{ marginTop: '3px' }}>ALTO</p>
            </div>
          </div>
        </div> */}
      </div>
    );
  };

  render() {
    const
      { alertas_count, alertas_data, enfermedad, email, evapoSum, week_data } = this.state, 
      { app, cultivo, cultivo_culti, data, superficie } = this.props
    ;

    const idRol = this.props.app.props.user.id_rol;
    let { activa, modelo } = this.state;
    modelo = true;
    
    return (
      <div className="especie-select">
        <div className="cultivo-block">
          {/* {alertas_count !== undefined || evapoSum !== 1
            ? this.renderNivelRiesgo(cultivo.enfermedades_data, alertas_count, evapoSum)
            : <div className="alerta-circle" style={{ backgroundColor: '#bfbfbf' }}/>
          } */}
          <div className="UPL-cultivo">{cultivo.cultivo}</div>
          <select defaultValue={0} onChange={this.select_enfermedad}>
            <option disabled hidden value={0} selected={!!cultivo.enfermedades_data.length > 0}>
              {cultivo.enfermedades_data.length > 0
                ? `Seleccionar enfermedad`
                : `No hay información`
              }
            </option>
            {cultivo.enfermedades_data.map((enfermedad, e) => 
              <option key={e} value={enfermedad.enfermedad}>{!enfermedad.enfermedad.includes(cultivo_culti) ? _.startCase(enfermedad.enfermedad).replace('nh', 'ñ') : _.startCase(_.join(_.dropRight(enfermedad.enfermedad.split('_')), '_')).replace('nh', 'ñ')}</option>
            )}
          </select>
          <form className="alerta-formUPL" onSubmit={this.submitAlarmaUPL}>
            {enfermedad !== '' && (idRol === 9 || idRol === 14 || idRol === 15)
              ? <input type="text" name="emailUPL" className="action-btn" placeholder="Ingrese Mail" value={email} onChange={this.emailChange} />
              : <input type="text" name="emailUPL" className="action-btn" disabled style={{ opacity: '0.5'}} />
            }
            <div className="guardarBtnUPL">
              {enfermedad !== '' && (idRol === 9 || idRol === 14 || idRol === 15)
                ? <button>Guardar</button>
                : <button disabled style={{ opacity: '0.5'}}>Guardar</button>
              }
            </div>
            <div className="alerta-switchUPL">
              <label className="switchUPL">
                {enfermedad !== '' && (idRol === 9 || idRol === 14 || idRol === 15)
                  ? <input type="checkbox" name="activateSwitch" checked={activa} onChange = {this.changeSwitch} />
                  : <input type="checkbox" name="activateSwitch" disabled style={{ opacity: '0.5'}} />
                }
                {enfermedad !== '' && (idRol === 9 || idRol === 14 || idRol === 15)
                  ? <span className="sliderUPL2 round" />
                  : <span className="sliderUPL2 round" style={{ opacity: '0.5'}} />
                }
              </label>
            </div>
          </form>
        </div>
        {/* <div  style={{display: 'flex', flexDirection: 'row', alignItems: 'center', justifyContent: 'center'}}> */}
        <div className='new-alert-container'>
          {cultivo.enfermedades_data.map((enfermedad, index) => (
            <div key={index} className='new-alert'>
              {alertas_count !== undefined || evapoSum !== 1
                ? this.renderNivelRiesgo(enfermedad, alertas_count, evapoSum)
                : <div className="alerta-circle" style={{ backgroundColor: '#bfbfbf' }} />
              }
              <p style={{fontSize: '15px', margin: 0}} value={enfermedad.enfermedad}>{!enfermedad.enfermedad.includes(cultivo_culti) ? _.startCase(enfermedad.enfermedad).replace('nh', 'ñ') : _.startCase(_.join(_.dropRight(enfermedad.enfermedad.split('_')), '_')).replace('nh', 'ñ')}</p>
            </div>
          ))}
        </div>
        {modelo && enfermedad !== '' &&
          <Modelo
            alertas_data={_.filter(alertas_data, alerta => alerta.enfermedad === enfermedad)}
            enfermedad={enfermedad}
            data={data}
            title={enfermedad}
            cultivo={cultivo_culti}
            week_data={week_data}
            app={app}
            superficie = {superficie}zf
            path={this.props.sen.path}
          />
        }
      </div>
    );
  }
}


// WEBPACK FOOTER //
// ./src/DialogSensorCultivoUPL.jsx